/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest, deleteRequest } from 'src/utils/RequestUtil';

export const crossSaleSearchAPI = function (data) {
    const url = `${config.baseUrl}cross-sale/search`;
    return postRequest({
        url,
        data,
    });
};

export const crossSaleCreateAPI = function (data) {
    const url = `${config.baseUrl}cross-sale`;
    return postRequest({
        url,
        data,
    });
};

export const crossSaleDeleteAPI = function ({
    crossSaleId,
}) {
    const url = `${config.baseUrl}cross-sale/${crossSaleId}`;
    return deleteRequest({
        url,
    });
};

export default {
    crossSaleSearchAPI,
    crossSaleCreateAPI,
    crossSaleDeleteAPI,
};
